import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import NormalLayout from "../components/layout/NormalLayout";
import axios from "axios";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Spinner,
  Badge,
} from "reactstrap";
import { AuthContext } from "../context/AuthContext";
import { Cookies } from "react-cookie";
import imgOrderStatus from "../assets/img/img_order_status.png";
import OrderSearch from "../components/search/OrderSearch";
import AirScheduleCalendar from "../components/schedule/AirScheduleCalendar";

const cookies = new Cookies();

function Main() {
  const { user } = useContext(AuthContext);
  const [products, setProducts] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  // Suppress lint warnings about unused variables
  void { user, setIsLoading };

  const [status, setStatus] = useState({
    REGISTERED: 0,
    PROCESSING: 0,
    DONE: 0,
    CANCEL: 0,
  });

  useEffect(() => {
    const orderStauts = async () => {
      try {
        const encodedWholesaler = encodeURIComponent(
          cookies.get("info").profile
        );
        setIsLoading(true);
        const resList = await axios.get(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/dashboard/order/status?wholesaler=${encodedWholesaler}`,
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );
        setIsLoading(false);

        // 1건 이상의 주문수가 있을 때만 출력
        if (resList.data.result === "success") {
          let tempStatusArr = resList.data.data.status;
          let statusObj = {};
          tempStatusArr.map((s) => [(statusObj[s.order_status] = s.count)]);
          setStatus(statusObj);
        }

        const resProduct = await axios.get(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/dashboard/specialproduct`,
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );

        // 1건 이상의 주문수가 있을 때만 출력
        if (resProduct.data.result === "success") {
          setProducts(resProduct.data.data);
        }
      } catch (error) {
        console.error("데이터를 불러오는데 실패했습니다", error);
      }
    };

    orderStauts();
  }, []);

  return (
    <NormalLayout>
      <div>
        <h3>주문현황</h3>
      </div>
      <div className="mt-3 mb-5">
        <div className="row">
          <div className="col-md-3">
            <Card>
              <CardBody className="text-center">
                <CardTitle tag="h5">주문등록 완료</CardTitle>
                <CardText>
                  <Link to="/manage/registered" className="fontsize_16rem">
                    {status.REGISTERED ? status.REGISTERED : 0}건
                  </Link>
                </CardText>
              </CardBody>
            </Card>
          </div>
          <div className="col-md-3">
            <Card>
              <CardBody className="text-center">
                <CardTitle tag="h5">주문 처리 중</CardTitle>
                <CardText>
                  <Link to="/manage/processing" className="fontsize_16rem">
                    {status.PROCESSING ? status.PROCESSING : 0}건
                  </Link>
                </CardText>
              </CardBody>
            </Card>
          </div>
          <div className="col-md-3">
            <Card>
              <CardBody className="text-center">
                <CardTitle tag="h5">발송완료</CardTitle>
                <CardText>
                  <Link to="/manage/done" className="fontsize_16rem">
                    {status.DONE ? status.DONE : 0}건
                  </Link>
                </CardText>
              </CardBody>
            </Card>
          </div>
          <div className="col-md-3">
            <Card>
              <CardBody className="text-center">
                <CardTitle tag="h5">주문취소</CardTitle>
                <CardText>
                  <Link to="/manage/cancel" className="fontsize_16rem">
                    {status.CANCEL ? status.CANCEL : 0}건
                  </Link>
                </CardText>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h5>주문 통합검색</h5>
        <OrderSearch />
      </div>
      <Row>
        <Col md={6}>
          <h5>항공 스케쥴</h5>
          <AirScheduleCalendar />
          <h5 className="mt-3">메뉴 안내</h5>
          <div className="border p-3">
            <Table hover>
              <tbody>
                <tr>
                  <td className="p-2" style={{ width: "90px" }}>
                    <li className="bold_600">주문서</li>
                  </td>
                  <td className="p-2 text-start">
                    '주문하기' 메뉴에서 엑셀파일로 주문하고, '주문목록'에서
                    주문내용을 상세히 확인할 수 있습니다.
                  </td>
                </tr>
                <tr>
                  <td className="p-2">
                    <li className="bold_600">주문관리</li>
                  </td>
                  <td className="p-2 text-start">
                    주문상태별로 주문건을 확인할 수 있습니다.
                  </td>
                </tr>
                <tr>
                  <td className="p-2">
                    <li className="bold_600">제품</li>
                  </td>
                  <td className="p-2 text-start">
                    제품공급가, 소매판매가 그리고 재고상태까지 제품정보를 확인할
                    수 있습니다.
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>

          <h5 className="mt-3">주문상태 안내</h5>
          <div className="border p-3">
            <img
              src={imgOrderStatus}
              style={{ width: "100%" }}
              alt="주문상태"
            />
            <Table hover className="mt-3">
              <tbody>
                <tr>
                  <td className="p-2" style={{ width: "120px" }}>
                    <li className="bold_600">주문등록 완료</li>
                  </td>
                  <td className="p-2 text-start">
                    주문서를 등록한 상태이며, 주문 삭제가 가능합니다.
                  </td>
                </tr>
                <tr>
                  <td className="p-2">
                    {" "}
                    <li className="bold_600">주문 처리 중</li>
                  </td>
                  <td className="p-2 text-start">
                    등록된 주문서를 기준으로 출고준비를 하는 단계입니다.
                  </td>
                </tr>
                <tr>
                  <td className="p-2">
                    {" "}
                    <li className="bold_600">발송완료</li>
                  </td>
                  <td className="p-2 text-start">
                    출고완료된 상태로, 주문건별로 무게, 배송비, 운송장번호를
                    확인할 수 있습니다.
                  </td>
                </tr>
                <tr>
                  <td className="p-2">
                    {" "}
                    <li className="bold_600">주문취소</li>
                  </td>
                  <td className="p-2 text-start">
                    고객의 요구나 다양한 이슈로 주문이 취소된 상태입니다.
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
        <Col md={6}>
          <h5>스페셜 할인제품</h5>
          <Table bordered striped hover>
            <thead>
              <tr className="table-primary">
                <th className="text-center" style={{ width: "80px" }}>
                  제품코드
                </th>
                <th className="text-center" style={{ width: "300px" }}>
                  상품명
                </th>
                <th className="text-center" style={{ width: "80px" }}>
                  특별가격
                </th>
                <th className="text-center cell">비고</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={4} className="text-center">
                    <Spinner animation="border" role="status" />
                  </td>
                </tr>
              ) : products && products.length > 0 ? (
                products.map((p, idx) => {
                  return (
                    <tr key={p.product_code}>
                      <td className="text-center">{p.product_code}</td>
                      <td className="text-start cell-300">{p.en_name}</td>
                      <td className="text-center">{p.price}</td>
                      <td className="text-center cell">{p.note}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    할인제품 없음
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </NormalLayout>
  );
}

export default Main;
